

import Vue from 'vue'
import App from './App'
import FastClick from 'fastclick'




const VueLazyLoad = () => import('vue-lazyload')
Vue.use(VueLazyLoad, {
error: require('./assets/logo.png'),
loading: require('./assets/defaultPic.jpg'),
/*attempt: 1,

listenEvents: [ 'scroll' ]*/
})

import VueRouter from 'vue-router'
import store from './vuex/store'
const Vuex = () => import('vuex')
import qs from 'qs'

import axios from 'axios'
import routes from './router/index'


/*const VueRouter = () => import('vue-router')
import store from './vuex/store'
const Vuex = () => import('vuex')
const axios = () => import('axios')
const qs = () => import('qs')
import routes from './router/index'*/

import LoadingPlugin from 'vux/src/plugins/loading/index.js'
import ToastPlugin from 'vux/src/plugins/toast/index.js'
import ConfirmPlugin from 'vux/src/plugins/confirm/index.js'

Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.use(ConfirmPlugin)





/*import backtop from './components/backtop'
Vue.use(backtop);
import sticky from './components/sticky'
Vue.use(sticky);
import scrollload from './components/scrollload'
Vue.use(scrollload);
import askDetail from './components/askDetail'
Vue.use(askDetail);
import footerNav from './components/footerNav'
Vue.use(footerNav);*/


Vue.component('c-menuList', require('@/components/c-menuList/c-menuList'));
Vue.component('backtop', require('./components/backtop/backtop.vue'));
Vue.component('sticky', require('./components/sticky/sticky.vue'));
Vue.component('scrollload', require('./components/scrollload/scrollload.vue'));
Vue.component('askDetail', require('./components/askDetail/askDetail.vue'));
Vue.component('footerNav', require('./components/footerNav/footerNav.vue'));
Vue.component('picCut', require('./components/picCut/picCut.vue'));









/*import './common/js/zepto.min'
import './common/js/sha1'
import './common/js/fontRatio'
import './common/js/all'
import './common/css/style.css'
import util from './common/js/util'*/


const sha1 = () => import('./common/js/sha1')
const fontRatio = () => import('./common/js/fontRatio')
const fontAwesome = () => import('font-awesome/css/font-awesome.min.css')
import './common/js/all'
import './common/css/style.css'
import util from './common/js/util'
import $app from './common/js/app'

Vue.use(fontRatio)
Vue.use(sha1)
Vue.use(fontAwesome)


Vue.prototype.appType = window.appType;
Vue.prototype.$app = $app;
Vue.prototype.util = util;
Vue.prototype.$util = util;
Vue.prototype.$fd = util.formatDate;
Vue.prototype.$post = util.post;
Vue.prototype.$get = util.get;
Vue.prototype.$state = store.state;
Vue.prototype.$ajax = axios;
Vue.prototype.$rootPath = store.state.common.root;
Vue.prototype.$pageCount = store.state.common.pageCount;



Vue.use(VueRouter)

Vue.use(Vuex)


const router = new VueRouter({

routes,
/*hashbang: false,
history: true,
saveScrollPosition: true,
suppressTransitionError: true*/
})

router.beforeEach((to, from, next) => {
/* 路由发生变化修改页面title */
if (to.meta.title) {
document.title = to.meta.title;
}
Vue.$vux.loading.hide();
next()
})

router.afterEach((transition) => {

if(transition.path == '/'){
setTimeout(()=>{
window.location.href = '/#/home';
})
}
})

FastClick.attach(document.body)

Vue.config.productionTip = false



axios.interceptors.request.use(config=>{



if(localStorage.getItem('wwb_uid')) config.headers['_uid'] = localStorage.getItem('wwb_uid');
if(store.state.headersTest) config.headers['test'] = store.state.headersTest;
config.headers['X-Requested-With'] = 'XMLHttpRequest';
config.headers['Content-Type'] = 'application/x-www-form-urlencoded';


if(typeof config.data == 'string' && config.data.indexOf('data:image') >= 0){//(/data:image/).test(config.data)
config.headers['Content-Type'] = 'application/json';
return config;
}


if(Array.isArray(config.data)){//[{name: 'gg', value: 'g1'}]提交格式
config.data = config.data.map((item)=>{
return item.name + '=' + item.value;
}).join('&');
}else{

let sja_string = '';
let para = 'split_joint_arr';
let arr = config.data && config.data[para];
if(arr && arr.length > 0){
let sja = arr;
delete config.data[para];
for(let o of sja){
sja_string += ('&' + qs.stringify(o, {arrayFormat: 'repeat'}));
}
}
config.data = qs.stringify(config.data, {arrayFormat: 'repeat'}) + sja_string;
}


return config;
}, error=>{

return Promise.reject(error);
});



axios.interceptors.response.use(response=>{

return response;
}, error=>{
console.log(error)
console.log(error.response.data)
let data = error.response.data;

if(data && data.error_code == 401){

console.log(data)

sessionStorage.removeItem('eswn_admin_loginInfo');
router.push({ path:'/login?v=' + Math.ceil(Math.random()*99999999999)});



return;
}


/*Iview.Message.error({
content: (data && data.error && data.error.length < 60) ? data.error : '网络异常，请稍后再试',
duration: 4,
closable: true
});*/


return Promise.reject(error);
});


/* eslint-disable no-new */
new Vue({
router,
store,
/*directives: {
TransferDom
},
components: {
Alert,
Group,
XSwitch,
Cell,
Loading,
XButton
},*/
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js